import React, { useState } from 'react';

import { InputV2 } from '@depop/web-ui-kit/InputV2';
import { getCookie, setCookie } from 'cookies-next/client';

import { PREVIEW_ENV_KEY } from '@/constants/cookies';

export function PreviewEnv() {
  const [value, setValue] = useState(getCookie(PREVIEW_ENV_KEY));

  function updateValue(value: string) {
    setValue(value);
    setCookie(PREVIEW_ENV_KEY, value);
  }

  return (
    <InputV2
      labelText="Preview environment"
      id="adminTool__previewEnv"
      value={value}
      onChange={(e) => updateValue(e.target.value)}
      onClear={() => updateValue('')}
    />
  );
}
